// eslint-disable-next-line no-restricted-imports
import { APP_MESSAGE } from 'components/Common/constants';

/**
 * This hook function returns an object with all app messages,
 * which can be used to inform user about some action's result (success or error)
 *
 * **Note**
 *
 * Although this hook could be replaced with a plain object, it's
 * recommended to use it anyway. Any possible introduction of translations
 * would be easier to do with a hook approach.
 * @returns {typeof APP_MESSAGE} object with available messages
 */
export const useAppMessages = () => {
  return {
    message: APP_MESSAGE,
  };
};
